import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EstadosPermisos } from '@core/types';
import { of as observableOf } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { UserService } from '.';

@Injectable()
export class PermissionsService {
  constructor(private _http: HttpClient, private userService: UserService) {}

  canShowCollapsable(CodPermiso: any) {
    const permisos = this.userService.user?.Permisos.map((p) => p.CodPermiso) || [];
    if (permisos.includes(CodPermiso)) {
      return this.checkPermission(CodPermiso);
    }
    return observableOf(true);
  }

  checkPermission(CodPermiso: number) {
    return this.userService.permissions$.pipe(
      take(1),
      map((my) => my.some((p) => p.CodPermiso === CodPermiso))
    );
  }

  checkAuthorizedPermission(CodPermiso: number) {
    return this.userService.permissions$.pipe(
      take(1),
      map((my) =>
        my.some(
          (p) =>
            p.CodPermiso === CodPermiso &&
            p.CodEstadoPermiso === EstadosPermisos.autorizado
        )
      )
    );
  }
}
